// extracted by mini-css-extract-plugin
export default {"container":"NM-z","modal":"OM-z","dimensions":"PM-z","brandName":"QM-z","productName":"RM-z","recipientEmail":"SM-z","recommendedFit":"TM-z","hiddenField":"UM-z"};